import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Typography from '@mui/material/Typography';
import { theme } from '@katalon-studio/katalon-ui';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';

export const TrialProducts = (
  { trialProducts }: {
    trialProducts: { [key: string]: { productCode: string; quantity: number }[] }
  },
) => (
  <Box
    id="trial-products"
    display="flex"
    flexDirection="column"
    marginTop={theme.spacing(2)}
  >
    {Object.entries(trialProducts).map(([key, products]) => (
      <Box
        key={`trial-category-${key}`}
        display="flex"
        flexDirection="column"
        marginBottom={theme.spacing(1)}
      >
        <Typography fontWeight={600} fontSize={14} color="#727993" marginBottom={theme.spacing(1)}>
          <FormattedMessage id={`product.group.${key}.trial.title`} />
        </Typography>
        {products.map(product => (
          <Box
            key={`trial-product-${product.productCode}`}
            display="flex"
            flexDirection="column"
            my={theme.spacing(1)}
          >
            <Box display="flex" flexDirection="row" alignItems="center">
              <TaskAltIcon
                sx={theme => ({
                  width: theme.spacing(2.25),
                  height: theme.spacing(2.25),
                  color: '#4CAF50',
                  marginX: theme.spacing(1.25),
                })}
              />
              <Typography fontSize={14} color="#233145">
                <FormattedMessage
                  id="trial.product.item"
                  values={{
                    productName: (
                      <FormattedMessage id={`${product.productCode}.trial.product.name`} />
                    ),
                    quantity: product.quantity,
                  }}
                />
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);
